module.exports = __webpack_public_path__ + "static/img/banner.618b4684.png";